import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import { STRINGS, TEAM } from "../../data/content";
import Navbar from "./Navbar";
import SiteFooter from "./SiteFooter";
import useFadeIn from "../../hooks/useFadeIn";

export default function BookPage() {
  const { t } = useLang();

  // Scroll to top on mount (in case user navigated here mid-scroll on the landing page)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Trigger the fade-in observer on this page too.
  useFadeIn([]);

  return (
    <div className="site-root">
      <Navbar />
      <section className="section book-page">
        <div className="section-inner">
          <div className="fade-in">
            <Link to="/" className="book-back-link">
              &larr; {t(STRINGS.backToHome)}
            </Link>
          </div>
          <h1 className="section-title fade-in" style={{ marginTop: 24 }}>
            {t(STRINGS.bookPageTitle)}
          </h1>
          <p className="section-sub fade-in">{t(STRINGS.bookPageSub)}</p>

          <div className="book-grid">
            {(() => {
              // Explicit display order for coaches with an active Calendly link.
              // Coaches not listed here fall back to their original TEAM order within their group.
              const activeOrder = [
                "frode-viberg-jermstad",
                "espen-bjornstad",
                "sindre-skjostad-lunke",
                "sindre-eid-hermansen",
              ];
              const priority = (id) => {
                const idx = activeOrder.indexOf(id);
                return idx === -1 ? 999 : idx;
              };
              return [...TEAM]
                .map((coach, originalIdx) => ({ coach, originalIdx }))
                .sort((a, b) => {
                  const aAvail = Boolean(a.coach.calendly);
                  const bAvail = Boolean(b.coach.calendly);
                  if (aAvail !== bAvail) return aAvail ? -1 : 1;
                  if (aAvail) return priority(a.coach.id) - priority(b.coach.id);
                  return a.originalIdx - b.originalIdx;
                })
                .map(({ coach }) => coach);
            })().map((coach) => {
              const available = Boolean(coach.calendly);
              return (
                <div className="book-card fade-in" key={coach.id}>
                  <img src={coach.img} alt={coach.name} className="book-photo" />
                  <div className="book-info">
                    <div className="book-name">{coach.name}</div>
                    <div className="book-role">{t(coach.role)}</div>
                    {available ? (
                      <a
                        href={coach.calendly}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn book-btn"
                      >
                        {t(STRINGS.bookThisCoach)}
                      </a>
                    ) : (
                      <button
                        type="button"
                        className="btn book-btn book-btn--disabled"
                        disabled
                        aria-disabled="true"
                      >
                        {t(STRINGS.bookUnavailable)}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
